export const actions = {
  ROLES_LOAD_REQUESTED: 'ROLES_LOAD_REQUESTED',
  ROLES_LOAD_SUCCEEDED: 'ROLES_LOAD_SUCCEEDED',
  ROLES_LOAD_FAILED: 'ROLES_LOAD_FAILED',
}

export const getLoadRolesAction = dispatch => {
  dispatch({
    type: actions.ROLES_LOAD_REQUESTED,
  })
}
